"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wordpressGetPage = exports.wordpressGetPageResultSchema = exports.wordpressGetPageArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// Argument schema
exports.wordpressGetPageArgsSchema = zod_1.z.object({
    pageUrl: zod_1.z.string().describe('The URL or ID of the WordPress page to fetch'),
});
// WordPress block schema
var wordpressBlockSchema = zod_1.z.lazy(function () {
    return zod_1.z.object({
        blockName: zod_1.z
            .string()
            .nullable()
            .describe('Block type (e.g., core/paragraph) or null for freeform HTML'),
        attrs: zod_1.z.record(zod_1.z.any()).describe('Block attributes'),
        innerHTML: zod_1.z.string().describe('Block inner HTML content'),
        innerContent: zod_1.z.array(zod_1.z.union([zod_1.z.string(), zod_1.z.null()])).describe('Block inner content array'),
        innerBlocks: zod_1.z.array(wordpressBlockSchema).describe('Nested blocks'),
    });
});
// Result schema
exports.wordpressGetPageResultSchema = zod_1.z.object({
    id: zod_1.z.number().describe('The WordPress page ID'),
    url: zod_1.z.string().describe('The public URL of the page'),
    title: zod_1.z.string().describe('The page title'),
    contentBlocks: zod_1.z.array(wordpressBlockSchema).describe('Parsed Gutenberg block structure'),
    contentHtml: zod_1.z.string().describe('The page content in HTML format'),
    excerpt: zod_1.z.string().nullish().describe('Optional brief description of the page'),
    status: zod_1.z.string().describe('The page status (publish, draft, pending, or private)'),
    slug: zod_1.z.string().describe('The URL-friendly slug'),
    modified: zod_1.z.string().describe('The last modified date (ISO 8601 format)'),
    author: zod_1.z.number().describe('The author user ID'),
});
// Tool definition
exports.wordpressGetPage = (0, common_1.createToolMetadata)({
    id: 'wordpressGetPage',
    displayName: 'WordPress Get Page',
    displayDescription: 'Fetch an existing WordPress page by URL or ID',
    category: 'communication',
    color: common_1.BRAND_COLORS.WORDPRESS,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.WORDPRESS),
    icon: 'wordpress',
    argsSchema: exports.wordpressGetPageArgsSchema,
}, exports.wordpressGetPageResultSchema);
